export default "/signup/_next/static/chunks/fonts/jerry-mini-a957abd1961108212acc1f613a0dec84.ttf";